import 'moment/locale/fi'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { render } from 'react-dom'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import { configureAmplify } from './config/amplify'
//import { initializeGoogleOptimize } from './config/googleOptimize'
import { initializeGTM } from './config/googleTagManager'
//import { initializeHotjar } from './config/hotjar'
import './index.css'
import './translations/i18n'

configureAmplify()
// change this for testing
// if (process.env.NODE_ENV === 'production') {
//   initializeHotjar()
// }
initializeGTM()
//initializeGoogleOptimize()

const rootElement = document.getElementById('root') as HTMLElement | null

const removeInitialSpinner = () => {
  const spinner = document.getElementById('initial-global-spinner')
  if (spinner && spinner.parentNode) {
    spinner.parentNode.removeChild(spinner)
  }
}

const waitForNavigationShell = () => {
  const hasAppContent = () => {
    if (document.querySelector('.navigation-content')) {
      return true
    }
    if (rootElement && rootElement.childElementCount > 0) {
      return true
    }
    return false
  }

  const removeIfReady = () => {
    if (hasAppContent()) {
      removeInitialSpinner()
      return true
    }
    return false
  }

  if (removeIfReady()) {
    return
  }

  const observerTarget = rootElement || document.body
  const observer = new MutationObserver(() => {
    if (removeIfReady()) {
      observer.disconnect()
    }
  })

  observer.observe(observerTarget, {
    childList: true,
    subtree: observerTarget === document.body
  })
}

if (rootElement) {
  render(<App />, rootElement, waitForNavigationShell)
} else {
  waitForNavigationShell()
}
